export const getPropertyFromObject = (obj, property: string) => {
  return Object.entries(obj).find((arr) => arr[0] === property)[1];
};
